import { ISO8601 } from '@adex/shared/models/date'


export function buildTime(isoDate: string | Date, showSeconds: boolean = false): string {
  const date = new Date(isoDate)
  const hours = date.getUTCHours()
  const minutes = date.getUTCMinutes()
  const result = `${ twoDigitFormat(hours) }:${ twoDigitFormat(minutes) }`
  if (!showSeconds) return result
  let seconds: number | string = date.getUTCSeconds()
  if (+seconds < 10) seconds = `0${seconds}`
  return result + `:${seconds}`
}

export function buildDate(isoDate: ISO8601 | Date): string {
  const date = new Date(isoDate)
  return `${ date.getUTCFullYear() }-${ shortDate(date) }`
}

export function shortDate(isoDate: ISO8601 | Date): string {
  const date = new Date(isoDate)
  return `${ twoDigitFormat(date.getUTCMonth() + 1) }-${ twoDigitFormat(date.getUTCDate()) }`
}

export function buildFullDate(isoDate: ISO8601 | Date, showSeconds?: boolean): string {
  return `${ buildDate(isoDate) } ${ buildTime(isoDate, showSeconds) }`
}

export function buildFullDateRange(isoFrom: ISO8601 | Date, isoTo: string | Date): string {
  const from = buildFullDate(isoFrom)
  const to = buildFullDate(isoTo)
  return `${ from } - ${ to }`
}

export function buildDateRange(isoFrom: ISO8601 | Date, isoTo: string | Date): string {
  const from = buildDate(isoFrom)
  const to = buildDate(isoTo)
  return `${ from } - ${ to }`
}

export function twoDigitFormat(val: string | number): string {
  return `${ +val < 10 ? `0${ val }` : val }`
}

export function buildWeekPeriod(): [ Date, Date ] {
  const today = endOfDay()
  const lastDay = new Date(today)
  lastDay.setDate(lastDay.getUTCDate() - 7)
  return [ lastDay, today ]
}

export function beginningOfDay(date: string | Date = new Date()): Date {
  const innerDate = new Date(date)
  innerDate.setHours(0)
  innerDate.setMinutes(0)
  innerDate.setSeconds(0)
  innerDate.setMilliseconds(0)
  return innerDate
}

export function endOfDay(date: string | Date = new Date()): Date {
  const innerDate = new Date(date)
  innerDate.setHours(23)
  innerDate.setMinutes(59)
  innerDate.setSeconds(59)
  innerDate.setMilliseconds(999)
  return innerDate
}

export function beginningOfYesterday(): Date {
  const date = new Date()
  const yesterday = getISOStringTimeExcludeOffset(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1))

  return new Date(yesterday)
}

export function getISOStringTimeExcludeOffset(value: string | Date): ISO8601 {
  const date = new Date(value)
  const cleanDate = new Date()
  cleanDate.setUTCFullYear(date.getFullYear())
  cleanDate.setUTCMonth(date.getMonth())
  cleanDate.setUTCDate(date.getDate())
  cleanDate.setUTCHours(date.getHours())
  cleanDate.setUTCMinutes(date.getMinutes())
  cleanDate.setUTCSeconds(date.getSeconds())
  cleanDate.setUTCMilliseconds(date.getMilliseconds())
  return cleanDate.toISOString()
}

export function addTimeOffset(value: string | Date): ISO8601 {
  const date = new Date(value)
  const offset = date.getTimezoneOffset() * 60000
  const cleanDate = new Date(date.getTime() + offset)
  return cleanDate.toISOString()
}

export function daysLeft(value: string | Date): number {
  const date = new Date(value)
  return Math.round((date.getTime() - (new Date()).getTime()) / (1000 * 3600 * 24))
}

export function secondToStringTime(sec: number | string): string {
  const numStr = parseFloat(`${ sec }`)
  const d = Math.floor(numStr / (3600 * 24))
  const h = Math.floor(numStr % (3600 * 24) / 3600)
  const m = Math.floor((numStr % 3600) / 60)
  const s = Math.floor(numStr % 60)
  let res = ''
  if (d > 0) res += `${ d }d `
  if (h > 0) res += `${ h }h `
  if (m > 0) res += `${ m }m `
  if (s > 0) res += `${ s }s `
  return res.length === 0 ? '0 s' : res
}

export function datePickerUTCValueAdapter(isoDate: ISO8601): Date {
  const date = new Date(isoDate)

  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
}

/**
 * Adapter for render UTC today date in Range Picker
 */
export function datePickerUTCTodayAdapter(isOpen: boolean): void {
  if (isOpen) {
    setTimeout(() => {
      const currentDate = new Date()
      const currentUTCTitle = `${currentDate.getUTCMonth() + 1}/${currentDate.getUTCDate()}/${currentDate.getUTCFullYear()}`

      const table = document.querySelector('table.ant-picker-content')
      const todayLocal = table.querySelector('.ant-picker-cell-today')
      const todayUTC = table.querySelector(`td[title="${currentUTCTitle}"]`)

      if (todayLocal !== todayUTC) {
        todayLocal.classList.remove('ant-picker-cell-today')
        todayUTC.classList.add('ant-picker-cell-today')
      }
    })
  }
}

export function checkDisabledDate(current: Date): boolean {
  return getISOStringTimeExcludeOffset(new Date()) < current.toISOString()
}
